import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=96ecc592&scoped=true&"
import script from "./battery.vue?vue&type=script&lang=js&"
export * from "./battery.vue?vue&type=script&lang=js&"
import style0 from "./battery.vue?vue&type=style&index=0&id=96ecc592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ecc592",
  null
  
)

export default component.exports